import { useUnread } from '@ethora/chat-component';
import { useEffect } from 'react';

interface UnreadBridgeProps {
  onUpdate: (data: {
    totalCount: number;
    loading: boolean;
    unreadByRoom: Record<string, number>;
  }) => void;
}

/**
 * Headless bridge component that calls the Ethora useUnread hook
 * and pushes results to the parent via callback.
 *
 * Loaded via @loadable/component (ssr: false) so it only runs client-side
 * inside XmppProvider where the hook is valid.
 */
export default function UnreadBridge({ onUpdate }: UnreadBridgeProps) {
  const unread = useUnread();

  useEffect(() => {
    onUpdate({
      totalCount: unread.totalCount,
      loading: unread.loading,
      unreadByRoom: unread.unreadByRoom,
    });
  }, [unread.totalCount, unread.loading, unread.unreadByRoom, onUpdate]);

  return null;
}
